import Loadable from 'react-loadable';
import Loading from 'System/views/loading.jsx';


const Clientlist = Loadable({
	loader: () => import(/* webpackChunkName: "Clients" */ "./views/ClientList.jsx"),
	loading: Loading
});

const Clientcontacts = Loadable({
	loader: () => import(/* webpackChunkName: "Clients" */ "./views/ClientContacts.jsx"),
	loading: Loading
});

const Orderdetail = Loadable({
	loader: () => import(/* webpackChunkName: "Orders" */ "./views/OrderDetail.jsx"),
	loading: Loading
});

const PortafoglioOrdini = Loadable({
	loader: () => import(/* webpackChunkName: "Orders" */ "./views/PortafoglioOrdini.jsx"),
	loading: Loading
});

const ConfirmedOrders = Loadable({
	loader: () => import(/* webpackChunkName: "Orders" */ "./views/ConfirmedOrders.jsx"),
	loading: Loading
});

const Sostituzioni = Loadable({
	loader: () => import(/* webpackChunkName: "Orders" */ "./views/Sostituzioni.jsx"),
	loading: Loading
});

const views = {
	Clientlist,
	Clientcontacts,
	Orderdetail,
	PortafoglioOrdini,
	ConfirmedOrders,
	Sostituzioni
}

export default views;
